import AppResource from 'general/constants/AppResource';
import update from 'immutability-helper';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from '../OtherKeenComponents/KTBSButton';
import KTBSDropdown, {
  KTBSDropdowAutoCloseBehavior,
  KTBSDropdownAlignments,
  KTBSDropdownDirections,
} from '../OtherKeenComponents/KTBSDropdown';
import DragItem from './DragItem';

DropdownTableConfigColumn2.propTypes = {
  onChangeCheckboxValue: PropTypes.func,
  resetDefaultTableColumn: PropTypes.func,
  onSelectAll: PropTypes.func,
  fullColumns: PropTypes.array,
  columnIds: PropTypes.array,
  fullColumnIds: PropTypes.array,
  onChangeFullColumnIds: PropTypes.func,
  direction: PropTypes.oneOf(Object.values(KTBSDropdownDirections)),
};

DropdownTableConfigColumn2.defaultProps = {
  onChangeCheckboxValue: null,
  resetDefaultTableColumn: null,
  onSelectAll: null,
  fullColumns: [],
  columnIds: [],
  fullColumnIds: [],
  onChangeFullColumnIds: null,
  direction: KTBSDropdownDirections.down,
};

/**
 *
 * @param {{
 * onChangeCheckboxValue: function,
 * resetDefaultTableColumn: function,
 * onSelectAll: function,
 * onUnSelectAll: function,
 * fullColumns: object[],
 * columnIds: string[],
 * fullColumnIds: string[],
 * onChangeFullColumnIds: function,
 * direction: string,
 * }} props
 * @returns
 */
function DropdownTableConfigColumn2(props) {
  // ---- params ----
  const {
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumns,
    columnIds,
    fullColumnIds,
    onChangeFullColumnIds,
    direction,
  } = props;
  const [items, setItems] = useState(fullColumnIds);
  const [toggle, setToggle] = useState(true);
  useEffect(() => {
    setItems(fullColumnIds);
  }, [fullColumnIds]);
  const { t } = useTranslation();
  const moveItem = useCallback((dragIndex, hoverIndex) => {
    setItems((prevItems) => {
      const tmp = update(prevItems, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevItems[dragIndex]],
        ],
      });
      return tmp;
    });
  }, []);

  return (
    <div>
      <DndProvider backend={HTML5Backend}>
        <KTBSDropdown
          contentEl={
            <div>
              <div
                className="p-4 d-flex flex-column gap-2 min-w-250px overflow-auto"
                style={{
                  maxHeight: '30vh',
                }}
              >
                {/* <h6 className="font-weight-bolder">Thiết lập cột</h6> */}
                {items.map((item, index) => {
                  return !_.isUndefined(item) ? (
                    <DragItem
                      id={item ?? index + ''}
                      label={_.find(fullColumns, (row) => row?.id === item)?.name}
                      checked={columnIds.includes(item)}
                      onCheckChanged={(id, checked) => {
                        onChangeCheckboxValue(id, checked);
                      }}
                      key={item ?? index + ''}
                      moveItem={moveItem}
                      index={index}
                      onDragDone={(item) => {
                        if (onChangeFullColumnIds) {
                          onChangeFullColumnIds(items);
                        }
                      }}
                    />
                  ) : (
                    <div key={index}></div>
                  );
                })}
              </div>
              <div className="d-flex w-100 align-items-center justify-content-start gap-2 pt-4 pb-2 px-4 border-top">
                <KTBSButton
                  bgColor="#EEF1FA"
                  title={t('Đặt làm mặc định')}
                  size={KTBSButtonSize.default}
                  borderRadius={5}
                  buttonTitleFontWeight="600"
                  onPress={() => {
                    resetDefaultTableColumn();
                    setToggle(true);
                  }}
                  buttonTitleColor={'#494968'}
                />

                <KTBSButton
                  color={KTBSButtonColor.success}
                  title={t('Lưu lại')}
                  size={KTBSButtonSize.default}
                  borderRadius={5}
                  buttonTitleFontWeight="600"
                  onPress={() => {}}
                />
              </div>
            </div>
          }
          alignment={KTBSDropdownAlignments.end}
          autoCloseBehavior={KTBSDropdowAutoCloseBehavior.outside}
          toggleElement={
            <KTBSButton
              bgColor="#EEF1FA"
              title={t('Thiết lập cột')}
              size={KTBSButtonSize.default}
              borderRadius={5}
              buttonTitleFontWeight="600"
              onPress={() => {}}
              iconElement={<img src={AppResource.icons.setColumnIcon} className="mb-1" alt="" />}
              buttonTitleColor={'#494968'}
            />
          }
          direction={direction}
        />
      </DndProvider>
    </div>
  );
}

export default DropdownTableConfigColumn2;
